// extracted by mini-css-extract-plugin
module.exports = {"corporatiu":"globals_corporatiu__SF1Nx"};